// extracted by mini-css-extract-plugin
export default {"header":"Thead_header__A0uM2","scrolled":"Thead_scrolled__MIRMo","th":"Thead_th__bT1sH","control":"Thead_control__gq30a"};